import PropTypes from "prop-types";
import React from "react";
import CommandHelpModal from "./CommandHelpModal";
import CommandLogModal from "./CommandLogModal";
import FloatingMicButton from "./FloatingMicButton";
import HiddenExportDataset from "./HiddenExportDataset";
import WidgetContent from "./WidgetContent";
import WidgetControlBar from "./WidgetControlBar";

const WidgetLayout = ({
  lastAttendanceDataset,
  floatingMicProps,
  widgetContainerProps,
  commandLogModalProps,
  commandHelpModalProps,
}) => {
  const {
    isVisible,
    widgetRef,
    isDragging,
    compactMode,
    position,
    showCommandLog,
    onMouseDown,
    controlBarProps,
    contentProps,
  } = widgetContainerProps;

  return (
    <div className="voice-command-widget-v2">
      <HiddenExportDataset dataset={lastAttendanceDataset} />
      <FloatingMicButton {...floatingMicProps} />

      {isVisible && (
        <div
          ref={widgetRef}
          className={`cue-widget ${isDragging ? "dragging" : ""} ${compactMode ? "compact" : ""}`}
          style={{
            left: position.x,
            top: position.y,
            display: "block",
            visibility: "visible",
            opacity: 1,
            zIndex: showCommandLog ? 1 : undefined,
            pointerEvents: showCommandLog ? "none" : "auto",
          }}
          onMouseDown={onMouseDown}
        >
          <WidgetControlBar {...controlBarProps} />
          <WidgetContent {...contentProps} />
        </div>
      )}

      <CommandLogModal {...commandLogModalProps} />
      <CommandHelpModal {...commandHelpModalProps} />
    </div>
  );
};

WidgetLayout.propTypes = {
  commandHelpModalProps: PropTypes.object.isRequired,
  commandLogModalProps: PropTypes.object.isRequired,
  floatingMicProps: PropTypes.shape({
    buttonRef: PropTypes.object,
    isVisible: PropTypes.bool.isRequired,
    micPosition: PropTypes.shape({
      x: PropTypes.number.isRequired,
      y: PropTypes.number.isRequired,
    }).isRequired,
    onClick: PropTypes.func.isRequired,
  }).isRequired,
  lastAttendanceDataset: PropTypes.array,
  widgetContainerProps: PropTypes.shape({
    compactMode: PropTypes.bool.isRequired,
    contentProps: PropTypes.object.isRequired,
    controlBarProps: PropTypes.object.isRequired,
    isDragging: PropTypes.bool.isRequired,
    isVisible: PropTypes.bool.isRequired,
    onMouseDown: PropTypes.func.isRequired,
    position: PropTypes.shape({
      x: PropTypes.number.isRequired,
      y: PropTypes.number.isRequired,
    }).isRequired,
    showCommandLog: PropTypes.bool.isRequired,
    widgetRef: PropTypes.object.isRequired,
  }).isRequired,
};

WidgetLayout.defaultProps = {
  lastAttendanceDataset: [],
};

export default WidgetLayout;

